(function($){
 

  $('.header__nav-button').click(function(){
    $('body').addClass('menu-open');
 
 });

 $( ".nav_child" ).mouseenter(function() {
  $('.page-overlay').addClass('is-visible');
})
$( ".nav_child" ).mouseleave(function() {
  $('.page-overlay').removeClass('is-visible');
});
 
 $('.close-btn').click(function(){
   $('body').removeClass('menu-open');
 
 });
 $('.page-overlay').click(function(){
  $('body').removeClass('menu-open');
   $('.desk-search_wrap').removeClass('active');
  $('body').removeClass('no-scroll');

});

$(".search-icon").click(function () {
  $(".desk-search_wrap").addClass("active"),
    setTimeout(function () {
      $("#goal-input").focus();
    }, 500);
  $('body').addClass('no-scroll');
  }),

  $('.search-i').click(function(){
  $('.desk-search_wrap').removeClass('active');
  $('body').removeClass('no-scroll');
  })
 
 $('.nav-element.dropdown>a').click(function(){
   $(this).toggleClass('open')
   $(this).next('.dropdown-menu').toggle(500)
 })

 $('.cart-i').click(function(){
  $('body').toggleClass('cart-open');
 });
 

  $('.page-overlay').click(function(){
    $('body').removeClass('cart-open');
   });

  if($(window).width() < 993)
    {
  $('.nav-element.dropdown>a').attr("href", "javascript:;")
    }
 

  $('.tab-menu li a').on('click', function(){
    var target = $(this).attr('data-rel');
 $('.tab-menu li a').removeClass('active');
    $(this).addClass('active');
    $("#"+target).fadeIn('slow').siblings(".tab-box").hide();
    return false;
});

function scaleToFill() {
  $('video.video-background').each(function(index, videoTag) {
     var $video = $(videoTag),
         videoRatio = videoTag.videoWidth / videoTag.videoHeight,
         tagRatio = $video.width() / $video.height(),
         val;
      
     if (videoRatio < tagRatio) {
         val = tagRatio / videoRatio * 1.02; // size increased by 2% because value is not fine enough and sometimes leaves a couple of white pixels at the edges
     } else if (tagRatio < videoRatio) {
         val = videoRatio / tagRatio * 1.02;
     }
     
     $video.css('transform','scale(' + val  + ',' + val + ')');
      $('video.video-background').show();
  });    
}

$(function () {
  scaleToFill();
  $('.video-background').on('loadeddata', scaleToFill);
  
  $(window).resize(function() {
      scaleToFill();
     
  });
});

// $('.collection_banner').each(function(){
//   $(this).find('img:first').hide();
//   var _Bg = 'url('+ $(this).find('img:first').attr('src') + ')';
//   $(this).css("background-image", _Bg);
//   $(this).find('img:first').hide();
// }); 

$('.hero-slider').slick({
  infinite: true,
  dots:false,
  arrows: true,
  prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0694/2985/4496/t/2/assets/angle-prev.svg?v=1675847731'></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0694/2985/4496/t/2/assets/angle-next.svg?v=1675847731'></button>",
  responsive: [
    {
      breakpoint: 767,
      settings: {
        dots:true,
      arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        dots:true,
        arrows: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.insta-slide').slick({
  infinite: true,
  dots:false,
  arrows: true,
 prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0694/2985/4496/t/2/assets/angle-prev.svg?v=1675847731'></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0694/2985/4496/t/2/assets/angle-next.svg?v=1675847731'></button>",
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '60px',
        arrows: false,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        arrows: false,
        centerPadding: '40px',
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]

});



  $('.collection-list-slide').slick({
  infinite: true,
  dots:true,
  arrows: true,
 prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0694/2985/4496/t/2/assets/angle-prev.svg?v=1675847731'></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0694/2985/4496/t/2/assets/angle-next.svg?v=1675847731'></button>",
  slidesToShow:4,
  slidesToScroll: 4,
  //centerMode: true,
  // centerPadding: '296px',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        // centerMode: true,
        // centerPadding: '60px',
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        // centerMode: true,
        // centerPadding: '60px',
        arrows: false,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        // centerMode: true,
        arrows: false,
        // centerPadding: '40px',
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]

});

var mode  = $(window).innerWidth() >= 767 ? "PC" : "MOBILE";
	
	if(mode=="PC"){

  }
	else if(mode=="MOBILE") {
    $('.product_img').slick({
      infinite: true,
      dots:true,
      arrows:false
      });

  }

$(window).scroll(function() {
  if ($(this).scrollTop() > 40){  
      $('body').addClass("sticky");
    }
    else{
      $('body').removeClass("sticky");
    }
  });
    

 


   $(window).on('load', function() {
          
          
           var now, lastDatePopupShowed;
      now = new Date();

      if (localStorage.getItem('lastDatePopupShowed') !== null) {
        lastDatePopupShowed = new Date(parseInt(localStorage.getItem('lastDatePopupShowed')));
      }

      if (((now - lastDatePopupShowed) >= (15 * 86400000)) || !lastDatePopupShowed) {
          setTimeout(function() {
  if (jQuery('#Newsletter-Popup').length) {
    jQuery.magnificPopup.open({
     items: {
         src: '#Newsletter-Popup' 
     },
     type: 'inline'
       
          });
    }
  }, 1050);
   
      	localStorage.setItem('lastDatePopupShowed', now);
         
    
      }
       
          
   
       });
    $(document).on('click', '.closePopup', function (e) 
             {
                 e.preventDefault();
                 $.magnificPopup.close();
             });

     
             $('.select-toggle').click(function(){
  $(this).next('.dropdown-menu').toggleClass('active');
 });
 $('.select-dropdown .dropdown-menu button').on('click', function() {
  var getValue = $(this).text();
  $('.select-dropdown .dropdown-menu>button').removeClass("active");
  $(this).addClass("active");
  $('.select-dropdown .dropdown-menu').removeClass("active");
});
$(".select-dropdown .dropdown-menu button ").click(function() {
  $(this).closest('.select-dropdown').find('.select-toggle ').text($(this).text());
});
    
    $('body').click(function() {
   $('.select-dropdown .dropdown-menu').removeClass("active");
});

$('.select-toggle').click(function(event){
   event.stopPropagation();
});       



     $('.filter-link').click(function(){
    $('.collection-sidebar').toggleClass('active');
       $('body').toggleClass('filters-open');
   });

  $('.page-overlay').click(function(){
    $('.collection-sidebar').removeClass('active');
     $('body').removeClass('filters-open');
   });
   $('.close-f').click(function(){
    $('.collection-sidebar').removeClass('active');
     $('body').removeClass('filters-open');
   });
  $('.close-filter').click(function(){
    $('.collection-sidebar').removeClass('active');
     $('body').removeClass('filters-open');
   });

  $("#pouup").on("click", function() {

jQuery.magnificPopup.open({
		    items: {
		        src: '#Newsletter-Popupp' 
		    },
		    type: 'inline',
             fixedContentPos: true,
		      
             });
  });
   AOS.init();
  
})(jQuery);


